var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFBAD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3333 33.5833V26.9333C42.3333 24.9732 42.3333 23.9931 41.9519 23.2444C41.6163 22.5858 41.0809 22.0504 40.4223 21.7148C39.6736 21.3333 38.6935 21.3333 36.7333 21.3333H29.2667C27.3065 21.3333 26.3264 21.3333 25.5777 21.7148C24.9191 22.0504 24.3837 22.5858 24.0481 23.2444C23.6667 23.9931 23.6667 24.9732 23.6667 26.9333V39.0667C23.6667 41.0269 23.6667 42.007 24.0481 42.7556C24.3837 43.4142 24.9191 43.9496 25.5777 44.2852C26.3264 44.6667 27.3065 44.6667 29.2667 44.6667H33M35.3333 31.8333H28.3333M30.6667 36.5H28.3333M37.6667 27.1667H28.3333M35.9167 41.1667L38.25 43.5L43.5 38.25",
    stroke: "#C91761",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#FFDEEC",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.f1ca7bac90b5c3d3914f770a15992a08.svg";
export { ForwardRef as ReactComponent };